
import {  UseFormClearErrors, UseFormGetValues, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import MgpTooltip from '../../../elements/MgpTooltip/MgpTooltip';
import MgpFormRadio from '../../../elements/MgpFormRadio/MgpFormRadio';
import { ERROR_MESSAGES, PSC_DATE } from '../../../const/AppConst';
import { useEffect, useState } from 'react';
import MgpMessage from '../../../elements/MgpMessage/MgpMessage';
import MgpFormInput from '../../../elements/MgpFormInput/MgpFormInput';
import MgpFormCheckbox from '../../../elements/MgpFormCheckbox/MgpFormCheckbox';
import useAppState from '../../../context/AppContext';
import { isWithinLast3Months } from '../../../utils/utils';

type BesoinInfoFormComponentProps = {
    register: UseFormRegister<any>;
    errors: any, 
    getValues?: UseFormGetValues<any>;
    setValue?: UseFormSetValue<any>;
    clearErrors?: UseFormClearErrors<any>;
    watch?: UseFormWatch<any>
}

export default function BesoinInfoFormComponent(
    {
        register, 
        errors, 
        getValues, 
        setValue, 
        clearErrors, 
        watch} : Readonly<BesoinInfoFormComponentProps>
) {

    const earliestDate= watch?.('earliestDate');
    const earliestDateForRecentlyRetired = watch?.('earliestDateForRecentlyRetired');

    const [hasOldMutual, setHasOldMutual] = useState<boolean|null>(getValues?.('hasOldMutual')??null);
    const [selectedDate, setSelectedDate] = useState<string>(getValues?.('effectiveDate')??'');
    const {
        state: { updatedProposition, hasActivePSC }
    } = useAppState();

    // calculate 'Au plus tot' = today + 1 month + 2 days
    let pickedDate =  new Date();
    pickedDate.setDate(pickedDate.getDate()+2)
    pickedDate.setMonth(pickedDate.getMonth()+1)
    if(pickedDate < new Date(PSC_DATE)){
        pickedDate = new Date(PSC_DATE);
    }
    // if retirementDate > pickedDate => set pickedDate value into retirementDate  
    if (updatedProposition?.retirementDate && 
        pickedDate < new Date(updatedProposition.retirementDate) ) {
        pickedDate = new Date (updatedProposition?.retirementDate)
    }

    useEffect(()=> {
        setValue?.('effectiveDate', selectedDate);
        if(getValues?.('effectiveDate')) {
            clearErrors?.('effectiveDate')
        }
    }, [selectedDate])

    useEffect(()=> {
        if(earliestDate === true){
            setSelectedDate(pickedDate.toISOString().split('T')[0]);
        }
    }, [earliestDate])

    useEffect(()=> {
        if(earliestDateForRecentlyRetired === true && updatedProposition?.retirementDate){
            setSelectedDate(updatedProposition?.retirementDate!);
        }
    }, [earliestDateForRecentlyRetired])

    const onHasOldMutualChange = (value: boolean)=> {
        setHasOldMutual(value);
        setSelectedDate('')
        setValue?.('effectiveDate', '')
        clearErrors?.('effectiveDate')
        if(value === false){
            setValue?.('earliestDate', false)
        }

        if(value === true){
            setValue?.('earliestDateForRecentlyRetired', false)
        }
    }

    const minDate = ()=> {
        let value
        let today = new Date();
        let PSC_date = new Date(PSC_DATE);
        if(hasOldMutual?.toString() === 'true'){
            value = pickedDate > PSC_date ? pickedDate : PSC_date;
        } else {
            if (PSC_date > today) {
                value = PSC_date;
            } else {
                value = today;
            }
            
        }
        return value.toISOString().split('T')[0];
    }

    const isRecentlyRetired = updatedProposition?.retirementDate ? isWithinLast3Months(updatedProposition?.retirementDate!) : false;
    console.log('hasActivePSC', hasActivePSC)

    return (             
        <>
            <h2 className='card-title bleu'>Date d'effet </h2>
            {
                !hasActivePSC &&
                <div className='mt-sm'>
                    <div className='form-check-label fw-medium text'>
                        <span>
                            J'ai une complémentaire santé depuis plus d'un an et 
                            je mandate la MGP pour effectuer les formalités de résiliation 
                            en mon nom, conformément à l'article L.221-10-2 du Code de la mutualité
                        </span>
                        <MgpTooltip text="Si vous avez souscrit depuis plus d'un an à une complémentaire santé, vous avez la possibilité 
                        de résilier celle-ci à tout moment sans motif. Si vous répondez oui, la MGP effectuera les démarches de résiliation 
                        auprès de votre ancien organisme et s'assurera de la continuité de votre couverture.">
                        <p className='info-badge info-icon' style={{marginTop: '-16px'}}>i</p></MgpTooltip>
                    </div>

                    <div className='form-row va-center jc-start' style={{width: "max-content"}} >     
                        <MgpFormRadio 
                                id='hasOldMutual'  
                                value='true' 
                                label='Oui' 
                                register={register} 
                                errors={errors} 
                                onClick={()=>{onHasOldMutualChange(true)}}
                        />
                        <MgpFormRadio 
                                id='hasOldMutual' 
                                value='false' 
                                label='Non' 
                                register={register} 
                                errors={errors}  
                                onClick={()=>{onHasOldMutualChange(false)}}
                        />
                    </div>     

                    {errors?.hasOldMutual 
                    &&<p className="error">{ERROR_MESSAGES.requiredMsg}</p>
                    }

                </div>
            }
           

            <p className='fw-medium text mt-sm'>Date d'adhésion souhaitée</p>
            
            {hasOldMutual 
            && getValues?.('hasOldMutual').toString() === 'true'
            &&<div className='form-group form-check mw-100'>     
                <MgpFormCheckbox 
                        register={register}
                         errors={errors} 
                         id='earliestDate' 
                         label='Au plus tôt' 
                />
            </div>                  
            }

            {
                isRecentlyRetired 
                && hasOldMutual?.toString() === 'false'
                &&<div className='form-group form-check mw-100'>     
                    <MgpFormCheckbox 
                            register={register}
                            errors={errors} 
                            id='earliestDateForRecentlyRetired' 
                            label="Je souhaite m'affilier à partir de ma date de retraite"
                    />
                </div>                  
            }

            <div className='form-row' >
                <div className='form-group mw-50'>
                {earliestDate !== true
                && earliestDateForRecentlyRetired !== true
                && <MgpFormInput
                        label=""
                        id="effectiveDate"
                        labelFontWeight='medium'
                        type='date'
                        register={register}
                        value={selectedDate}
                        errors={errors}
                        min={minDate()}
                        onChange={(e)=> setSelectedDate(e.target.value)}
                    />}
                </div>
            </div>
           
            {
                isRecentlyRetired 
                && earliestDateForRecentlyRetired
                && hasOldMutual?.toString() === 'false' 
                && <div className='bg-bleu-clair blanc p-md ta-justify'>
                        <p className='text'>Vous avez un délai de 3 mois à compter de votre départ à la retraite pour prolonger votre couverture santé.</p>
                        <p className='text'>Ce contrat est sans participation de votre employeur. Votre cotisation et celle de vos ayants droit est intégralement à votre charge.</p>
                        <p className='text'>Si vous choisissiez la continuité de votre couverture santé, vous serez couvert de manière rétroactive :</p>
                        <p className='text'>- Le premier appel à cotisations en tiendra compte</p>
                        <p className='text'>- Le premier prélèvement sera plus élevé que les suivants.</p>
                    </div>
            }

           {earliestDate 
            && <MgpMessage
                    type='info' 
                    message="Au lendemain de la prise d'effet de la résiliation auprès de votre ancien organisme" /> 
            }


        </>         
  )
}
